import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import localData from "../../localData";
import { Button } from "../../components";
import { motion } from "framer-motion";

export default function Navbar() {
    const location = useLocation();

    const { togglerIcon, close } = localData.svgs;
    const { logo } = localData.images;

    // COLLAPSE
    let navbarCollapse = useRef();
    const [isCollapsing, setIsCollapsing] = useState(false);
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        if (!isCollapsing) return;
        setIsShown(!isShown);
    }, [isCollapsing]);

    return (
       <>
         <nav className="navbar">
             <div className="container-fluid">
                 <Link className="navbar-brand" to="/">
                    <img src= {logo} alt='logo' />
                    
                 </Link>
                 <button
                     className={`navbar-toggler ${isShown ? "collapsed" : ""}`}
                     type="button"
                     onClick={() => setIsCollapsing(true)}
                 >
                     <span className="navbar-toggler-icon">{togglerIcon}</span>
                 </button>
                 <div
                 tabIndex="0"
                     ref={navbarCollapse}
                     className={`navbar-collapse ${isCollapsing ? "collapsing" : "collapse"} ${isShown ? "show" : ""}`}
                     id="navbarSupportedContent"
                     onTransitionEnd={() => setIsCollapsing(false)}
                     style={isShown && isCollapsing ? { opacity: 1 } : {}}
                 >
                     <span className="close" onClick={() => setIsCollapsing(true)}>{close}</span>
        
                     <ul className="navbar-nav me-auto">
                         <li className="nav-item">
                             <Link
                                 to="/"
                                 className={`nav-link  ${"/" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="home"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 home
                             </Link>
                         </li>
                         <li className="nav-item">
                             <Link
                                 to="/what-we-do"
                                 className={`nav-link ${"/what-we-do" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="what-we-do"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 what we do
                             </Link>
                         </li>
                         <li className="nav-item">
                             <Link
                                 to="/about"
                                 className={`nav-link ${"/about" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="about"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 who we are
                             </Link>
                         </li>
                         <li className="nav-item">
                             <Link
                                 to="/works"
                                 className={`nav-link ${"/works" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="works"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 works
                             </Link>
                         </li>
                         <li className="nav-item">
                             <Link
                                 to="/contact"
                                 className={`nav-link ${"/contact" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="contact"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 speak to an expert
                             </Link>
                         </li>
                         <li className="nav-item">
                             <Link
                                 to="/blog"
                                 className={`nav-link ${"/blog" === location.pathname ? "active" : ""}`}
                                 aria-current="page"
                                 data-target="blog"
                                onClick={()=> setIsCollapsing(true)}
                             >
                                 blog
                             </Link>
                         </li>
                     </ul>

                     <div className="circle circle-danger circle-top-left "></div>
                     <div className="circle circle-primary circle-bottom-right"></div>
                 </div>
             </div>
         </nav>
         <div className={`navbar-overlay ${isShown ? 'show': ''}`} onClick={()=>setIsCollapsing(true)}></div>
       </>
    );
}
